export default {
  reset_password_title: "Passwort zurücksetzen",
  reset_pass_desc:
    "Bitte geben Sie Ihre E-Mail-Adresse ein, und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
  reset_pass: "Passwort zurücksetzen",
  reset_pass_requested: "Anfrage zum Zurücksetzen des Passworts erhalten",
  reset_pass_check_email:
    "Bitte überprüfen Sie Ihre E-Mail und folgen Sie den Anweisungen zum Zurücksetzen Ihres Passworts.",
  reset_pass_email_sent_info:
    "Wenn diese E-Mail in unserem System existiert, wurde ein Link zum Zurücksetzen des Passworts gesendet.",
  reset_pass_did_not_receive: "Keine E-Mail erhalten? Bitte überprüfen Sie Ihren Spam-Ordner.",
  reset_pass_resend_email: "E-Mail zum Zurücksetzen des Passworts erneut senden",
  reset_pass_resend_available_in: "Erneutes Senden in {seconds} Sekunden verfügbar",
  reset_pass_resending: "Wird erneut gesendet...",
  reset_pass_resent_success: "E-Mail zum Zurücksetzen des Passworts erfolgreich erneut gesendet",
  reset_pass_please_wait: "Bitte warten Sie {seconds} Sekunden vor dem erneuten Senden",
  reset_pass_request_failed: "Anfrage zum Zurücksetzen des Passworts fehlgeschlagen",
  email_required: "Bitte geben Sie Ihre E-Mail-Adresse ein",
  email_invalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  email_placeholder: "ihre{0}beispiel.com",
  daily_limit_reached: "Tägliches Versandlimit erreicht. Bitte morgen erneut versuchen.",
  remaining_attempts: "Heute noch {count} Versuche übrig",
};
